import { create } from "zustand";
import { UserAdminInfo, UserResource } from "../api/users";

interface UsersState {
  users: UserAdminInfo[];
  nextToken?: string;
  loading: boolean;
  error: string | null;
  emailFilter?: string;
  rcStoreFilter?: string;
  rcStatusFilter?: string;
  rcIdFilter?: string;
  loadUsers: (filter?: string, rcStore?: string, rcStatus?: string, rcId?: string) => Promise<void>;
  loadNextPage: () => Promise<void>;
}

export const useUsersStore = create<UsersState>((set, get) => ({
  users: [],
  nextToken: undefined,
  loading: false,
  error: null,
  emailFilter: undefined,
  rcStoreFilter: undefined,
  rcStatusFilter: undefined,
  rcIdFilter: undefined,

  loadUsers: async (filter?: string, rcStore?: string, rcStatus?: string, rcId?: string) => {
    set({ loading: true, error: null, emailFilter: filter, rcStoreFilter: rcStore, rcStatusFilter: rcStatus, rcIdFilter: rcId });
    try {
      if (rcStore || rcStatus) {
        const response = await UserResource.getUsersByRcProvider({ store: rcStore, status: rcStatus, filter });
        set({ users: response.users, nextToken: response.nextToken, loading: false });
      } else {
        const response = await UserResource.getList({ filter, revenuecatId: rcId });
        set({ users: response.users, nextToken: response.nextToken, loading: false });
      }
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load users";
      set({ error, loading: false });
    }
  },

  loadNextPage: async () => {
    const { nextToken, emailFilter, rcStoreFilter, rcStatusFilter, rcIdFilter, users } = get();
    if (!nextToken) return;
    set({ loading: true });
    try {
      if (rcStoreFilter || rcStatusFilter) {
        const response = await UserResource.getUsersByRcProvider({ store: rcStoreFilter, status: rcStatusFilter, filter: emailFilter, nextToken });
        set({ users: [...users, ...response.users], nextToken: response.nextToken, loading: false });
      } else {
        const response = await UserResource.getList({ filter: emailFilter, revenuecatId: rcIdFilter, nextToken });
        set({ users: [...users, ...response.users], nextToken: response.nextToken, loading: false });
      }
    } catch (err) {
      const error = err instanceof Error ? err.message : "Failed to load more users";
      set({ error, loading: false });
    }
  },
}));
